import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { ArticleComponent } from './template/containers/article/article.component';
import { HomeComponent } from './template/containers/home/home.component';
import { SearchComponent } from './template/containers/search/search.component';
import { LoginComponent } from './template/containers/login/login.component';
import { ForgotPasswordComponent } from './template/containers/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './template/containers/reset-password/reset-password.component';
import { RegisterComponent } from './template/containers/register/register.component';
import { NewsComponent } from './template/containers/news/news.component';
import { EventsComponent } from './template/containers/events/events.component';
import { ProfilesComponent } from './template/containers/profiles/profiles.component';
import { ProfileComponent } from './template/containers/profile/profile.component';
import { ContactComponent } from './template/containers/contact/contact.component';
import { ClubsComponent } from './template/containers/clubs/clubs.component';
import { PageComponent } from './template/containers/page/page.component';
import { ErrorComponent } from './template/containers/error/error.component';
import { AccountComponent } from './template/containers/account/account.component';
import { PartnersComponent } from './template/containers/partners/partners.component';
import { NewsSectionComponent } from './template/containers/news-section/news-section.component';

const appRoutes: Routes = [
    {
      path: '',
      pathMatch: 'full',
      component: HomeComponent,
      data: {
        title: 'The only target shooting governing body in Great Britain',
        description: 'The only target shooting governing body in Great Britain',
        image: 'The only target shooting governing body in Great Britain',
      },
    },
    {
      path: 'search',
      component: SearchComponent,
      data: { title: 'Search' },
    },
    {
      path: 'search/:term',
      component: SearchComponent,
      data: { title: 'Search' },
    },
    {
      path: 'account',
      component: AccountComponent,
      data: { title: 'Account' },
    },
    {
      path: 'login',
      component: LoginComponent,
      data: { title: 'Login' },
    },
    {
      path: 'forgot-password',
      component: ForgotPasswordComponent,
      data: { title: 'Forgot Password' },
    },
    {
      path: 'reset-password/:passwordResetHash',
      component: ResetPasswordComponent,
      data: { title: 'Reset Password' },
    },
    {
      path: 'register',
      component: RegisterComponent,
      data: { title: 'Register' },
    },
    {
      path: 'news',
      component: NewsComponent,
      data: { title: 'News' },
    },
    {
      path: 'news/:type',
      component: NewsSectionComponent,
      data: { title: 'News' },
    },
    {
      path: 'events',
      component: EventsComponent,
      data: { title: 'Events' },
    },
    {
      path: 'article/:id/:handle',
      component: ArticleComponent,
      data: { title: 'News', type: 'article' },
    },
    {
      path: 'article/:id',
      component: ArticleComponent,
      data: { title: 'News', type: 'article' },
    },
    {
      path: 'profiles/:type',
      component: ProfilesComponent,
      data: { title: 'Profile' },
    },
    {
      path: 'profile/:id',
      component: ProfileComponent,
      data: { title: 'Profile' },
    },
    {
      path: 'profile/:id/:name',
      component: ProfileComponent,
      data: { title: 'Profile' },
    },
    {
      path: 'contact',
      component: ContactComponent,
      data: { title: 'Contact' },
    },
    {
      path: 'contact/:type',
      component: ContactComponent,
      data: { title: 'Contact' },
    },
    {
      path: 'clubs',
      component: ClubsComponent,
      data: { title: 'Clubs' },
    },
    {
      path: 'partners',
      component: PartnersComponent,
      data: { title: 'Partners' },
    },
    {
      path: 'partners/:type',
      component: PartnersComponent,
      data: { title: 'Partners' },
    },
    {
      path: 'page/:handle',
      component: PageComponent,
      data: { title: 'Info' },
    },
    {
      path: 'error/not-found',
      data: { breadcrumb: 'Not Found', title: 'Not Found' },
      component: ErrorComponent,
    },
    {
      path: '**',
      redirectTo: '/error/not-found',
    },
  ];

  const routingOptions: ExtraOptions = {
    enableTracing: false,
    scrollPositionRestoration: 'enabled',
  };

  export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(appRoutes, routingOptions);
